module.exports = __webpack_public_path__ + "static/media/csharp.ea181510.svg";